import { NgOptimizedImage } from "@angular/common";
import { Component, computed, input } from "@angular/core";
import { DirectusTranslationPipe } from "../../../../common/pipes/directus-translation.pipe";
import { GetDirectusImagePipe } from "../../../../common/pipes/get-directus-image.pipe";
import {
    sanitizeDirectusObject,
    sanitizeDirectusRelationArray
} from "../../../../common/utils/sanitize-directus-object";
import { ItemsPartnerBlock } from "../../../api/packbo/models/items-partner-block";

@Component({
    selector: "packbo-partner-block",
    templateUrl: "./partner-block.template.html",
    imports: [DirectusTranslationPipe, GetDirectusImagePipe, NgOptimizedImage]
})
export class PartnerBlockComponent {
    public readonly partnerBlock = input.required<ItemsPartnerBlock>();
    public readonly partners = computed(() =>
        sanitizeDirectusRelationArray(this.partnerBlock().partners_refs, "partners_id").map(sanitizeDirectusObject)
    );
}
